"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyDelivery = void 0;
/**
 * Record of delivery of what is supplied.
 */
var SupplyDelivery = /** @class */ (function () {
    function SupplyDelivery() {
    }
    return SupplyDelivery;
}());
exports.SupplyDelivery = SupplyDelivery;
(function (SupplyDelivery) {
    SupplyDelivery.StatusEnum = {
        InProgress: 'in-progress',
        Completed: 'completed',
        Abandoned: 'abandoned',
        EnteredInError: 'entered-in-error'
    };
})(SupplyDelivery = exports.SupplyDelivery || (exports.SupplyDelivery = {}));
exports.SupplyDelivery = SupplyDelivery;
